import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// Lazy load components for better performance
const SelfServiceDashboard = lazy(() => import('./SelfServiceDashboard'));
const ProfileManagement = lazy(() => import('./components/ProfileManagement'));
const LeaveRequests = lazy(() => import('./components/LeaveRequests'));
const TeamLeaveApprovals = lazy(() => import('./components/TeamLeaveApprovals'));
const ExpenseClaims = lazy(() => import('./components/ExpenseClaims'));
const PayslipAccess = lazy(() => import('./components/PayslipAccess'));
const TimeTracking = lazy(() => import('./components/TimeTracking'));
const TrainingEnrollment = lazy(() => import('./components/TrainingEnrollment'));
const Tasks = lazy(() => import('./components/Tasks'));
const PersonalTasks = lazy(() => import('./components/PersonalTasks'));
const TaskReporting = lazy(() => import('./TaskReporting'));
const Notifications = lazy(() => import('./components/Notifications'));
const DocumentManagement = lazy(() => import('./components/DocumentManagement'));
const Benefits = lazy(() => import('./components/Benefits'));
const MyPerformanceReviews = lazy(() => import('./components/MyPerformanceReviews'));
const AppraisalPage = lazy(() => import('./appraisal/AppraisalPage'));

const SelfService = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route index element={<SelfServiceDashboard />} />
        <Route path="profile" element={<ProfileManagement />} />
        <Route path="leave-requests" element={<LeaveRequests />} />
        <Route path="team-leave-approvals" element={<TeamLeaveApprovals />} />
        <Route path="expense-claims" element={<ExpenseClaims />} />
        <Route path="payslips" element={<PayslipAccess />} />
        <Route path="time-tracking" element={<TimeTracking />} />
        <Route path="training" element={<TrainingEnrollment />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="personal-tasks" element={<PersonalTasks />} />
        <Route path="my-tasks" element={<TaskReporting />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="documents" element={<DocumentManagement />} />
        <Route path="benefits" element={<Benefits />} />
        <Route path="performance-reviews" element={<MyPerformanceReviews />} />
        <Route path="appraisal" element={<AppraisalPage />} />
        {/* Add more self-service routes here */}
      </Routes>
    </Suspense>
  );
};

export default SelfService;